import styled from "styled-components";
import SectionTitle from "./SectionTitle";
import { useEffect, useMemo, useRef } from "react";
import Card from "./Card";
import FadeInItem from "./FadeInItem";
import { handleLink } from "../utils/handleLink";
import { BREAK_POINT } from "../constants";

const Goods = () => {
  const goodsList = useMemo(
    () => [
      {
        link: "https://www.emotioncastle.com/products/120811781",
        id: "goods_1.webp",
        title: "매지컬 컴팩트 가방세트",
      },
      {
        link: "https://www.emotioncastle.com/products/120811778",
        id: "goods_2.jpg",
        title: "매지컬 로드 장갑세트",
      },
      {
        link: "https://www.emotioncastle.com/products/120811777",
        id: "goods_3.jpg",
        title: "사랑의 하츄핑 하우스",
      },
    ],
    []
  );

  const mouseDownRef = useRef(false);
  const goodsListRef = useRef<HTMLDivElement>(null);
  const positionRef = useRef<{ clientX: number; scrollLeft: number }>({
    clientX: 0,
    scrollLeft: 0,
  });

  useEffect(() => {
    goodsListRef.current?.addEventListener("mousedown", (e: MouseEvent) => {
      mouseDownRef.current = true;

      if (positionRef?.current && goodsListRef.current) {
        positionRef.current.clientX = e.pageX - goodsListRef.current.offsetLeft;
        positionRef.current.scrollLeft = goodsListRef.current.scrollLeft;
      }
    });

    goodsListRef.current?.addEventListener("mouseup", (e: MouseEvent) => {
      mouseDownRef.current = false;
    });

    goodsListRef.current?.addEventListener("mouseleave", () => {
      mouseDownRef.current = false;
    });

    goodsListRef.current?.addEventListener("mousemove", (e: MouseEvent) => {
      e.preventDefault();

      if (!mouseDownRef.current) return;
      if (positionRef?.current && goodsListRef.current) {
        const x = e.pageX - goodsListRef.current.offsetLeft;
        const walk = x - positionRef.current.clientX;
        goodsListRef.current.scrollLeft = positionRef.current.scrollLeft - walk;
      }
    });

    goodsListRef.current?.addEventListener("click", (e: MouseEvent) => {
      if (
        window.innerWidth < 1150 &&
        positionRef.current.clientX !== e.clientX
      ) {
        e.stopPropagation();
        e.preventDefault();
      }
    });
  }, []);

  return (
    <Wrapper id="goods">
      <SectionTitle>GOODS</SectionTitle>
      <FadeInItem point={0.25}>
        <GoodsWrapper>
          <div ref={goodsListRef}>
            {goodsList.map((goods) => (
              <Card
                key={goods.id}
                id={goods.id}
                title={goods.title}
                handleClick={() => handleLink(goods.link)}
              />
            ))}
          </div>
        </GoodsWrapper>
      </FadeInItem>
    </Wrapper>
  );
};

export default Goods;

const Wrapper = styled.div`
  padding: 140px 0 210px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    padding: 80px 0 128px;
  }
`;

const GoodsWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  > div {
    @media only screen and (min-width: 1150px) {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      margin-top: 100px;
      gap: 30px;
    }

    @media only screen and (max-width: 1150px) {
      width: 100%;
      display: flex;
      gap: 16px;
      padding: 0 16px;
      overflow-x: scroll;
      margin-top: 24px;
    }
  }
`;
